import { useState } from "react";
import { toast } from "sonner";
import { useStore } from "./store";

export const useCrud = (key, blank, validate, label) => {
  const store = useStore();
  const [form, setForm] = useState(null);
  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});
  const [delId, setDelId] = useState(null);

  const openNew = (init = {}) => { setEditId(null); setErrors({}); setForm({ ...blank(), ...init }); };
  const openEdit = (row) => { setEditId(row.id); setErrors({}); setForm({ ...row }); };
  const close = () => setForm(null);
  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const save = (e, transform = (x) => x) => {
    e?.preventDefault();
    const errs = validate(form);
    setErrors(errs);
    if (Object.keys(errs).length) return toast.error("Please fix the highlighted fields");
    const item = transform(form);
    if (editId) store.update(key, editId, item);
    else store.add(key, item);
    toast.success(`${label} ${editId ? "updated" : "added"}`);
    close();
  };
  const confirmDelete = () => { store.remove(key, delId); setDelId(null); toast.success(`${label} deleted`); };

  return { form, setForm, editId, errors, openNew, openEdit, close, change, save, delId, setDelId, confirmDelete };
};
